import { Entry } from '../Entry'

export function Entry20230405() {
  return (
    <Entry title="Apr 5 2023 - v3.3.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13779/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
